import { render, staticRenderFns } from "./DownloadLink.vue?vue&type=template&id=57b774a0&scoped=true&"
import script from "./DownloadLink.vue?vue&type=script&lang=js&"
export * from "./DownloadLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b774a0",
  null
  
)

export default component.exports